<template src="./template.html"></template>

<script>
  import { mapState } from 'vuex'
  import { http } from '@/api/http'

  export default {
    name: 'PaymentKlarna',
    data() {
      return {
        token: '',
        type: '',
      }
    },
    computed: {
      ...mapState('payment', ['activePaymentService']),
    },
    async created() {
      //  load klarna script only once
      // ignore this at the moment
      // await this.loadKlarnaBox()
    },
    methods: {
      async loadKlarnaBox() {
        const self = this

        await http.get(`carts/mine/payment/${this.activePaymentService}`).then(({ data }) => {
          self.token = data.token
          self.type = data.type
        })

        if (typeof Klarna === 'undefined') return false

        try {
          // eslint-disable-next-line no-undef
          Klarna.Payments.init({ client_token: this.token })
          // eslint-disable-next-line no-undef
          Klarna.Payments.load({ container: '#klarna-payments-container', payment_method_category: this.type })
        } catch (ex) {
          // document.location.href = '/checkout/purchase?err=klarna';
          // console.log('Error: ', ex)
        }
      },
    },
  }
</script>
